export default function validate(values){
    const errors = {}
    if (!values.promoter_email)
      errors.promoter_email = 'Debes definir un correo electrónico.'
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.promoter_email))
        errors.promoter_email = 'Ingresa un correo electrónico válido'

    return errors
}